import { z } from 'zod';
import { $NaturalNumber, i18nAttributes, uuid } from '../../utils';
import { DeepRequired } from '../../../utils';
import { RedocSchemaObject, extendApi } from '../../openapi';

export const level = extendApi(
  z.object({
    id: uuid,
    i18nAttributes: i18nAttributes(
      extendApi(
        z.object({
          name: extendApi(z.string(), { description: 'Name of the level' }),
        }),
        {
          examples: [{ name: 'Gold' }, { name: 'Or' }],
        },
      ),
    ),
    minCurrencyAmount: extendApi($NaturalNumber, {
      description: 'Number of points the members must obtain to gain this level',
      example: 500,
    }),
  }),
  {
    description:
      'Level that a member can reach in a program based on the amount of points they obtained',
    tags: ['level-model', 'level', 'model'],
  } as RedocSchemaObject,
);

export const publicLevelRef = extendApi(level, {
  $ref: '#/components/schemas/Level',
} as RedocSchemaObject);

export type PublicLevel = DeepRequired<z.infer<typeof level>>;
